var _line, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomesolutionLandlord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 38,
    viewBox: "0 0 181 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 17.5,
    x2: 144,
    y2: 17.5,
    stroke: "#192BC2",
    strokeWidth: 3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    width: 37,
    height: 38,
    fill: "#192BC2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M165.531 7.20312V30H161.031V12.3906L155.625 14.1094V10.5625L165.047 7.20312H165.531Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomesolutionLandlord);
export default __webpack_public_path__ + "static/media/Home.solution.Landlord.4cdf91e26e370dfcfd1de731ac262762.svg";
export { ForwardRef as ReactComponent };